import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/detail/store';
import { RootState as C_RootState } from '@Redux/common/store';
import cN from 'classnames';
import styles from '../style.module.scss';
import DayAttractions from './DayAttractions';
import DayIntro from './DayIntro';
import DayInclusions from './DayInclusions';
interface I_Props {
    mealType: Array<number>;
    trafficIcon: { [key: string]: JSX.Element };
    toggleLightBox: (reqDayID: number, reqPOIID: string) => void;
}

const WholeMode: React.FC<I_Props> = ({ mealType, trafficIcon, toggleLightBox }) => {
    const ItineraryInfo = useSelector((store: RootState) => store.itinerariesReducer);
    const DailyList = ItineraryInfo.DailyList;
    const { curPage } = useSelector((store: C_RootState) => store.pageReducer);
    return (
        <>
            {DailyList.map((dailyItem: { DayID: string | number | null | undefined }) => (
                <div className={styles.wholeMode} key={dailyItem.DayID}>
                    <div
                        className={cN(styles.dayTripWrapper, {
                            [`${styles.printModeWrapper}`]: curPage === 'print',
                        })}
                    >
                        <DayIntro dailyItem={dailyItem} />
                        <DayInclusions
                            dailyItem={dailyItem}
                            mealType={mealType}
                            toggleLightBox={toggleLightBox}
                            trafficIcon={trafficIcon}
                        />
                        <DayAttractions dailyItem={dailyItem} toggleLightBox={toggleLightBox} />
                    </div>
                </div>
            ))}
        </>
    );
};

export default WholeMode;
